import 'polyfills/browser';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import HowItWorksPage from 'components/Landing/HowItWorksPage/HowItWorksPage';

import { registerComponents } from '../src/registrations';

registerComponents({ HowItWorksPage });
